(function () {
  'use strict';

  angular
    .module('appFileDownload')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('appFileDownload', {
        url: '/app-file-download',
        views : {
        	'appFileDownloadView' : {
        		templateUrl: 'app-file-download/views/app-file-download.tpl.html',
                controller: 'AppFileDownloadCtrl',
                controllerAs: 'appFileDownload'
        	}
        }
      });
  }
}());
